import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core'
import * as L from 'leaflet'

@Component({
    selector: 'app-swppp-map',
    template: '<div #mapHost class="swppp-map"></div>',
    styles: [
        `
            .swppp-map {
                height: 420px;
                width: 100%;
                border: 1px solid #dee2e6;
                border-radius: 4px;
            }
        `,
    ],
    standalone: true,
})
export class SwpppMapComponent implements AfterViewInit, OnChanges {
    @ViewChild('mapHost', { static: true }) mapHost!: ElementRef<HTMLDivElement>
    @Input() latitude = 40.3
    @Input() longitude = -111.7
    @Input() zoom = 10
    @Output() picked = new EventEmitter<{ latitude: number; longitude: number }>()

    private map?: L.Map
    private marker?: L.Marker

    ngAfterViewInit() {
        const streets = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; OpenStreetMap',
            maxZoom: 19,
        })
        const satellite = L.tileLayer(
            'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            { attribution: 'Esri', maxZoom: 19 },
        )
        this.map = L.map(this.mapHost.nativeElement).setView([this.latitude, this.longitude], this.zoom)
        streets.addTo(this.map)
        L.control.layers({ Map: streets, Satellite: satellite }).addTo(this.map)
        this.map.on('click', event => {
            this.moveMarker(event.latlng.lat, event.latlng.lng)
            this.picked.emit({ latitude: event.latlng.lat, longitude: event.latlng.lng })
        })
        this.moveMarker(this.latitude, this.longitude)
        setTimeout(() => this.map?.invalidateSize(), 200)
    }

    ngOnChanges() {
        if (!this.map) return
        this.moveMarker(this.latitude, this.longitude)
        this.map.setView([this.latitude, this.longitude])
    }

    private moveMarker(latitude: number, longitude: number) {
        if (!this.map || latitude == null || longitude == null) return
        const icon = L.divIcon({
            className: 'swppp-pin',
            html: '<div style="background:#0d6efd;width:16px;height:16px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 2px #000"></div>',
            iconSize: [16, 16],
            iconAnchor: [8, 8],
        })
        if (!this.marker) {
            this.marker = L.marker([latitude, longitude], { icon, draggable: true }).addTo(this.map)
            this.marker.on('dragend', () => {
                const latlng = this.marker!.getLatLng()
                this.picked.emit({ latitude: latlng.lat, longitude: latlng.lng })
            })
        } else {
            this.marker.setLatLng([latitude, longitude])
        }
    }
}
